import { createSelector } from 'reselect';
import { preAssessmentDetails } from '@/selectors/merchant';

export const getDefaultState = createSelector(
  preAssessmentDetails,
  ({ yearlyAcquiredVolume, paymentDelay, paymentInterval, volumeByCard }) => ({
    yearlyAcquiredVolume,
    paymentDelay,
    paymentInterval,
    volumeByCard,
  }),
);
